/* DON'T EDIT THIS FILE: edit original and run build again */ import { Jsonable } from "../../framework/core/jsonable.ts";

export const deletePropertyDeleter = (
  current: Record<string, Jsonable>,
  path: string
): void => {
  delete current[path];
};
